import LogoutComponent from '../../features/Authentication/Logout/LogOut';

export default function Logout() {
  return (
    <LogoutComponent />
  )
}
